import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { racesAPI } from '@/services/racesApi';
import { queryKeys } from './queryKeys';

export function useRaces(params?: any) {
  return useQuery({
    queryKey: queryKeys.races.all(params),
    queryFn: () => racesAPI.getRaces(params),
  });
}

export function useRace(id?: any) {
  return useQuery({
    queryKey: queryKeys.races.detail(id),
    queryFn: () => racesAPI.getRaceById(id),
    enabled: !!id,
  });
}

export function useCreateRace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (raceData: any) => racesAPI.createRace(raceData),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.races._def }),
  });
}

export function useUpdateRace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => racesAPI.updateRace(id, data),
    onSuccess: (_data: any, { id }: any) => {
      qc.invalidateQueries({ queryKey: queryKeys.races._def });
      qc.invalidateQueries({ queryKey: queryKeys.races.detail(id) });
    },
  });
}

export function useDeleteRace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => racesAPI.deleteRace(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.races._def }),
  });
}
